var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "share-banner" },
    [
      _c(
        "VsButton",
        {
          attrs: { icon: "fa:facebook-official" },
          on: {
            click: function($event) {
              return _vm.share($event, "shareFB")
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.tI18n.share) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "VsButton",
        {
          attrs: { icon: "fa:twitter" },
          on: {
            click: function($event) {
              return _vm.share($event, "shareTW")
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.tI18n.tweet) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "VsButton",
        {
          attrs: { icon: "fa:envelope" },
          on: {
            click: function($event) {
              return _vm.share($event, "shareEmail")
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.tI18n.email) + "\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }